<template>
  <div class="content-container flex-column">
    <div class="grid-x toolbar fixed">
      <div class="cell auto">
        <h4 class="no-margin toolbar-title">Auksjoner</h4>
      </div>
    </div>

    <div class="content-container flex-row no-flex-grow">
      <section class="content xlarge-padding">
        <div class="grid-x grid-padding-x grid-padding-large">
          <div class="cell" v-if="hasAccess('expert')">
            <ul>
              <li><router-link :to="{ name: 'Forhandsbud' }">Registrere forhåndsbud</router-link></li>
              <li><router-link :to="{ name: 'Spader' }">Opprette spadenummer</router-link></li>
              <li><router-link :to="{ name: 'Telefonbud' }">Registrere telefonbudgivere</router-link></li>
              <li><router-link :to="{ name: 'Tilslagsskjermbilde' }">Tilslagsskjermbilde</router-link></li>
              <li><router-link :to="{ name: 'Auksjon', params: { avdeling: 'nett' } }">Ny nettauksjon</router-link></li>
              <li><router-link :to="{ name: 'Auksjon', params: { avdeling: 'klassisk' } }">Ny klassisk auksjon</router-link></li>
              <li><router-link :to="{ name: 'Auksjon', params: { avdeling: 'vin' } }">Ny vinauksjon</router-link></li>
            </ul>
          </div>
          <div class="cell" v-if="hasAccess('consultant')">
            <ul>
              <li><router-link :to="{ name: 'Tilslagsskjermbilde' }">Tilslagsskjermbilde</router-link></li>
            </ul>
          </div>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AuctionsList'
}
</script>



// WEBPACK FOOTER //
// src/components/Admin/Auctions/AuctionsList.vue